import React from "react";
import { Col, Row } from "react-bootstrap";
import Button from "@mui/material/Button";
import { Tree } from 'primereact/tree';
import Langs from "../../../app/lang/langs";
import ImageButton from "../../buttons/ImageButton";
import addIcon from '../../../assets/images/addIconGray.png';
import addIconFocus from '../../../assets/images/addIconOrange.png';
import excelIcon from '../../../assets/images/excelIcon.png';
import excelIconFocus from '../../../assets/images/excelIconFocus.png';
import exportIcon from '../../../assets/images/export.png';
import exportIconFocus from '../../../assets/images/exportFocus.png';
import { useDispatch } from "react-redux";
import { setAddElementModalVisibility } from "../vcompSlice";
import TabNavigationButtons from "./TabNavigationButtons";

/**
 * EditFormTab - Renders the edit form tree with drag-and-drop (case 3).
 * Allows reordering categories/aptitudes, expanding/collapsing tree, and excel import/export.
 */
export default function EditFormTab({
    isMobile,
    mode,
    nodesInProject,
    expandedKeysEdit,
    onToggleExpanded,
    expandAll,
    collapseAll,
    nodeTemplate,
    onNodeDoubleClick,
    onDragDrop,
    projectAptitudes,
    onCreateProject,
    onSetExcelModalVisibility,
    onExtractExcelProject,
    // Navigation
    onPrevious,
    onNext,
}) {
    const dispatch = useDispatch();

    let position;
    if (projectAptitudes) {
        position = projectAptitudes.categories?.length;
    } else {
        position = 0;
    }

    const editTreeHeader = () => {
        return (
            <div className="">
                <ImageButton
                    image={excelIcon}
                    imageFocus={excelIconFocus}
                    onClick={() => {
                        onSetExcelModalVisibility(true);
                    }}
                    active={true}
                    width={32}
                />
                {mode == 'edit' && onCreateProject && onCreateProject.nom &&
                    <ImageButton
                        image={exportIcon}
                        imageFocus={exportIconFocus}
                        onClick={() => {
                            onExtractExcelProject(nodesInProject, onCreateProject.nom);
                        }}
                        active={true}
                        width={32}
                    />
                }
                <ImageButton
                    image={addIcon}
                    imageFocus={addIconFocus}
                    onClick={() => {
                        dispatch(setAddElementModalVisibility({ visibility: true, element: null, subcategory: false, pos: position }));
                    }}
                    active={true}
                    width={32}
                />
            </div>
        );
    };

    return (
        <div>
            <div
                className={`card ${isMobile === 2 ? 'mt-5 d-flex justify-content-center align-content-center border-0' : 'p-3 m-4 d-flex justify-content-center align-content-center border-0'}`}
                style={isMobile === 2 ? { height: '85%', display: 'flex', flexDirection: 'column' } : {}}
            >
                <Row>
                    <Col xs={4} className="d-flex p-1 ps-4 justify-content-start align-items-center">
                        <Langs str="EDIT_PROJECT_FORM" />
                    </Col>
                    <Col xs={8} className={`d-flex justify-content-end ${isMobile === 2 ? '' : 'p-2'}`}>
                        <Button
                            variant="outlined"
                            size={isMobile === 2 ? 'small' : 'medium'}
                            onClick={expandAll}
                            sx={{
                                mr: 1,
                                textTransform: 'none',
                                borderColor: 'rgba(0,0,0,0.2)',
                                color: '#4b5263',
                                '&:hover': { borderColor: 'rgba(0,0,0,0.4)', backgroundColor: 'rgba(0,0,0,0.03)' },
                            }}
                        >
                            <Langs str="Expand All" />
                        </Button>
                        <Button
                            variant="outlined"
                            size={isMobile === 2 ? 'small' : 'medium'}
                            onClick={collapseAll}
                            sx={{
                                mr: 1,
                                textTransform: 'none',
                                borderColor: 'rgba(0,0,0,0.2)',
                                color: '#4b5263',
                                '&:hover': { borderColor: 'rgba(0,0,0,0.4)', backgroundColor: 'rgba(0,0,0,0.03)' },
                            }}
                        >
                            <Langs str="Collapse All" />
                        </Button>
                        {editTreeHeader()}
                    </Col>
                </Row>
                <div style={{ flex: 1, overflowY: 'auto' }}>
                    <div style={{ height: isMobile === 2 ? "calc(100vh - 300px)" : "calc(100vh - 220px)" }}>
                        <Tree
                            value={nodesInProject}
                            dragdropScope="demo"
                            onNodeDoubleClick={(e) => { onNodeDoubleClick(e) }}
                            nodeTemplate={nodeTemplate}
                            filter={true}
                            filterPlaceholder="Search..."
                            onDragDrop={(e) => { onDragDrop(e) }}
                            showHeader={true}
                            className="w-full md:w-30rem custom-tree border-0"
                            expandedKeys={expandedKeysEdit}
                            onToggle={(e) => onToggleExpanded(e.value)}
                        />
                    </div>
                </div>
                {isMobile === 2 && (
                    <TabNavigationButtons
                        isMobile={isMobile}
                        mode={mode}
                        onPrevious={mode !== "edit" ? onPrevious : null}
                        onNext={onNext}
                        nextLabel={mode === "edit" ? <Langs str="SAVE" /> : <Langs str="Next" />}
                    />
                )}
            </div>
            {isMobile !== 2 && (
                <TabNavigationButtons
                    isMobile={isMobile}
                    mode={mode}
                    onPrevious={mode !== "edit" ? onPrevious : null}
                    onNext={onNext}
                    nextLabel={mode === "edit" ? <Langs str="SAVE" /> : <Langs str="Next" />}
                />
            )}
        </div>
    );
}
